import {Injectable} from "@angular/core";
import {ConnectionBackend, RequestOptions, Request, RequestOptionsArgs, Response, Http, Headers} from "@angular/http";
import {Observable} from "rxjs/Rx";
import {AuthenticationService} from "./authentication.service";
import {switchMap} from "rxjs/operators";

@Injectable()
export class HttpSecure extends Http {


    private _baseUrl: string;
    public get baseUrl() {
        return this._baseUrl;
    }

    constructor(
        backend: ConnectionBackend,
        defaultOptions: RequestOptions,
        private authService: AuthenticationService,
    ) {
        super(backend, defaultOptions);
        this._baseUrl = this._defaultOptions.url;
        this._defaultOptions.url = null;
    }

    handleRequest(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.authService
            .getJwtToken()
            .pipe(
                switchMap((token: string) => {
                    this._defaultOptions.headers.set("Authorization", "Bearer " + token);
                    return super.request(this._baseUrl + url, {...this._defaultOptions, ...options})
                })
            )
    }

    request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: options.method,
                    body: options.body
                }
            });
    }

    get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: "get"
                }
            });
    }

    post(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: "POST",
                    body: body
                }
            });
    }

    postFile(url: string, body: FormData, clientId: string): Observable<Response> {
        return this.authService
            .getJwtToken()
            .pipe(
                switchMap((token: string) => {
                    let headers = new Headers();
                    /** In Angular 5, including the header Content-Type can invalidate your request */
                    // headers.append("Content-Type", "multipart/form-data");
                    headers.append("Authorization", "Bearer " + token);
                    headers.append("Accept", "application/json");
                    return super.request(this._baseUrl + url + "?clientId=" + clientId, new RequestOptions({
                        headers: headers,
                        method: "POST",
                        body: body
                    }))
                })
            )
    }

    put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: "PUT",
                    body: body
                }
            });
    }

    delete(url: string, body: any, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: "DELETE",
                    body: body
                }
            });
    }

    options(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
        return this.handleRequest(url,
            {
                ...options,
                ...{
                    method: "options"
                }
            });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/authentication/service/httpSecure.service.ts